import { getClientHeaders } from '@vigilkids/device-fingerprint'

const DEFAULT_APP_VERSION = '1.0.0'

export function createCheckoutRequestHeadersResolver(
  productCode: string,
  clientVersion?: string
): () => Promise<Record<string, string>> {
  return async () => {
    try {
      const deviceHeaders = await getClientHeaders({
        productCode,
        appVersion: clientVersion || DEFAULT_APP_VERSION,
      })

      const headers: Record<string, string> = {}
      if (deviceHeaders['X-Device-ID']) {
        headers['X-Device-ID'] = deviceHeaders['X-Device-ID']
      }

      return headers
    } catch {
      return {}
    }
  }
}
